module.exports = __webpack_public_path__ + "img/2_167.8aa71ae1.png";